export const systemMessages = {
  total: 77,
  limit: 77,
  skip: 0,
  data: [
    {
      id: 2,
      name: 'Submit Assessment',
      message: 'Are you sure you want to submit the answers?',
      handler: 'assessment.submit',
      messageType: 'success',
      hidden: false,
      createdAt: '2019-09-03T08:27:24.797Z',
      updatedAt: '2019-09-03T08:27:24.797Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 3,
      name: 'Delete question',
      message:
        'Sorry, but you cannot delete a question that’s already associated with a recommendation.  Please remove the recommendation logic and return to delete the question',
      handler: 'question.delete.restriction',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.466Z',
      updatedAt: '2019-10-28T16:13:49.466Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 4,
      name: 'Recommendation remove warning',
      message: 'Are you sure you want to remove this recommendation?',
      handler: 'reccomendation.remove.warning',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 5,
      name: 'Recommendation remove condtion from logic warning',
      message: 'Are you sure you want to remove this condition?',
      handler: 'reccomendation.remove.logic.condition.question',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 6,
      name: 'Recommendation output remove Warning',
      message: 'Are you sure you want to remove this output?',
      handler: 'reccomendation.output.remove.warning',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 7,
      name: 'Recommendation logic required fields validation error',
      message: 'Recommendation logic is required',
      handler: 'reccomendation.logic.validation.error',
      messageType: 'error',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 8,
      name: 'Recommendation output required fields validation error',
      message: 'Recommendation outputs is required',
      handler: 'reccomendation.output.validation.error',
      messageType: 'error',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 9,
      name: 'Recommendation output duplicate fields error',
      message: 'Recommendation output fields (role, placement) should be unique',
      handler: 'reccomendation.output.duplicates.error',
      messageType: 'error',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 10,
      name: 'Assessment version change error on recommendation logic page',
      message: "There was a change in assessment, can't load logic",
      handler: 'reccomendation.assessment.version.change.error',
      messageType: 'error',
      hidden: false,
      createdAt: '2019-10-28T16:13:49.676Z',
      updatedAt: '2019-10-28T16:13:49.676Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 11,
      name: 'Questionnaire version change',
      message: 'This questionnaire has been updated',
      handler: 'questionnaire.version.change',
      messageType: 'info',
      hidden: false,
      createdAt: '2019-11-18T20:13:17.226Z',
      updatedAt: '2019-11-18T20:13:17.226Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 12,
      name: 'Retake questionnaire',
      message: 'Are you sure you want to retake this questionnaire?',
      handler: 'questionnaire.retake',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-11-18T20:13:17.226Z',
      updatedAt: '2019-11-18T20:13:17.226Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 13,
      name: 'Dedu loading error message',
      message: 'Sorry, but the learning center is not available right now.  Please try again later.',
      handler: 'dedu.timeout',
      messageType: 'error',
      hidden: false,
      createdAt: '2019-11-18T20:13:17.254Z',
      updatedAt: '2019-11-18T20:13:17.254Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 14,
      name: 'Goal Completion',
      message:
        'You just completed the goal “@goalTitle”. Keep it up!  See how many goals you’ve completed in the “Achievements” section of the goals page or your dashboard.',
      handler: 'goal.complete',
      messageType: 'info',
      hidden: false,
      createdAt: '2019-12-20T15:01:30.327Z',
      updatedAt: '2019-12-20T15:01:30.327Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 15,
      name: 'Goal Activation',
      message: 'You just activated the goal “@goalTitle”. Find this goal in the “Active Goals” section of the goals page or your dashboard.',
      handler: 'goal.activate',
      messageType: 'info',
      hidden: false,
      createdAt: '2019-12-20T15:01:30.327Z',
      updatedAt: '2019-12-20T15:01:30.327Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 16,
      name: 'Dismiss Confirmation',
      message:
        'Are you sure you want to dismiss the “@goalTitle”? It’s through small steps that great things can be accomplished! But don’t worry, you can always reactivate a goal when you’re ready. Choose new goals on the goals page or from your dashboard.',
      handler: 'goal.dismiss.confirmation',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-12-20T15:01:30.327Z',
      updatedAt: '2019-12-20T15:01:30.327Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 17,
      name: 'Dismiss',
      message:
        'You successfully dismissed the goal “@goalTitle”, but don’t worry, you can always reactivate a goal when you’re ready. Choose new goals on the goals page or from your dashboard.',
      handler: 'goal.dismiss.success',
      messageType: 'info',
      hidden: false,
      createdAt: '2019-12-20T15:01:30.327Z',
      updatedAt: '2019-12-20T15:01:30.327Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 22,
      name: 'Delete progress note',
      message: 'Are you sure you want to delete this draft note? This action cannot be undone and will cause this note to be inaccessible.',
      handler: 'delete.progress.note',
      messageType: 'warning',
      hidden: false,
      createdAt: '2020-04-06T17:59:32.213Z',
      updatedAt: '2020-04-06T17:59:32.213Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 31,
      name: 'Not Permitted page',
      message: "Sorry, it seems that you don't have permssion to view this page",
      handler: 'not.permitted.page',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:46.346Z',
      updatedAt: '2020-04-21T14:33:46.346Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 1,
      name: 'Provider multiple send  chat',
      message:
        'Because this message has multiple patients, it will not display the "to" list to the patient. Please keep the contents of the message generic to also protect patient privacy.\t',
      handler: 'messaging.chat.multiple.participants',
      messageType: 'warning',
      hidden: false,
      createdAt: '2019-09-03T08:27:24.303Z',
      updatedAt: '2020-01-28T16:13:52.711Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 18,
      name: 'Mapped Data Warning',
      message:
        "Changing the organization will result in the loss of mapped data points for this assessment's questions,\n      are you sure you want to continue?",
      handler: 'assessment.mappedData.warning',
      messageType: 'warning',
      hidden: false,
      createdAt: '2020-01-28T16:55:18.504Z',
      updatedAt: '2020-01-28T16:55:18.504Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 19,
      name: 'Associated Recommendation Error',
      message: 'You cannot change the organization as this assessment has recommendations associated with it.',
      handler: 'assessment.recommendation.error',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-01-28T16:55:18.514Z',
      updatedAt: '2020-01-28T16:55:18.514Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 20,
      name: 'Deactivate patient',
      message: 'Are you sure you want to deactivate',
      handler: 'deactivate.patient',
      messageType: 'warning',
      hidden: false,
      createdAt: '2020-02-14T16:00:07.637Z',
      updatedAt: '2020-02-14T16:00:07.637Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 21,
      name: 'Activate patient',
      message: 'Are you sure you want to reactivate',
      handler: 'activate.patient',
      messageType: 'warning',
      hidden: false,
      createdAt: '2020-02-14T16:00:08.520Z',
      updatedAt: '2020-02-14T16:00:08.520Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 23,
      name: 'Orientation welcome message',
      message:
        "Thank you for choosing Evolve as your partner to help you achieve your health and fitness goals. We can't wait to help you find the strategies that work uniquely for YOU. \nAre you ready?",
      handler: 'orientation.welcome',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.307Z',
      updatedAt: '2020-04-21T14:33:44.307Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 24,
      name: 'Orientation dashboard message',
      message:
        'Personalized tools are at your fingertips, making it easy to track progress and check-in with your provider. \nOur comprehensive tools and medical management are key to significant and sustained weight loss.',
      handler: 'orientation.dashboard',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.316Z',
      updatedAt: '2020-04-21T14:33:44.316Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 25,
      name: 'Orientation learning message',
      message:
        'Our engaging content is backed by over 30 years of scientific research to recommend strategies that work best for achieving your goals.',
      handler: 'orientation.learning',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.336Z',
      updatedAt: '2020-04-21T14:33:44.336Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 27,
      name: 'Orientation goals message',
      message:
        'Small changes add up to help develop habits that are enjoyable and can last a lifetime. We focus on setting manageable, short-term goals that will get you closer to your milestones.',
      handler: 'orientation.goals',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.336Z',
      updatedAt: '2020-04-21T14:33:44.336Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 28,
      name: 'Orientation questionnaire message',
      message:
        'Answer a few questions to help your provider know about your past experiences, so we can provide you with new, personalized tools. Together, we can achieve success!',
      handler: 'orientation.questionnaire',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.336Z',
      updatedAt: '2020-04-21T14:33:44.336Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 26,
      name: 'Orientation recommendation message',
      message:
        'Your uniquely tailored recommendations are informed by your answers to our comprehensive assessment and will change as you make progress. ',
      handler: 'orientation.recommendation',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.335Z',
      updatedAt: '2020-04-21T14:33:44.335Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 29,
      name: 'Orientation logging message',
      message:
        'Track your food, activity, and weight on a daily basis to see your progress over time. Logging is one of the most research-supported strategies for weight loss and maintenance! \nYour provider will follow along and suggest strategies that will work uniquely for you.',
      handler: 'orientation.logging',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:44.341Z',
      updatedAt: '2020-04-21T14:33:44.341Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 32,
      name: 'Error pages header',
      message: "Oops, that didn't work",
      handler: 'error.pages.header',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-25T12:09:21.440Z',
      updatedAt: '2020-04-25T12:09:21.440Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 30,
      name: 'Not Found page',
      message: 'We’re sorry, but we can’t find what you’re looking for.',
      handler: 'not.found.page',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-04-21T14:33:46.310Z',
      updatedAt: '2020-05-09T16:52:28.831Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 33,
      name: 'Insights information message',
      message: 'Please note: The Insights data is updated once per day, so the most recent data may not be displayed yet.',
      handler: 'insights.information',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-05-15T21:27:22.352Z',
      updatedAt: '2020-05-15T21:27:22.352Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 35,
      name: 'Provider orientation dashboard message',
      message:
        'Everything to manage your day is in one convenient location. Program statistics, daily calendar, action items, and patient messages are all available for you.',
      handler: 'orientation.provider.dashboard',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.347Z',
      updatedAt: '2020-06-18T09:14:58.347Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 36,
      name: 'Provider orientation patient list message',
      message: 'Easily locate patients who need support. Sort and filter patients by success metrics, status in the program, and custom tags.',
      handler: 'orientation.provider.patientList',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.358Z',
      updatedAt: '2020-06-18T09:14:58.358Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 37,
      name: 'Provider orientation patient record message',
      message:
        "Customized care recommendations and medical decision support tools are available in every patient record. Our scientifically-based approach means you'll get treatment suggestions based on patient's current status, medical and weight history. Monitor and communicate with your patient using tools like goal setting and food and exercise logs.",
      handler: 'orientation.provider.patientRecord',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.360Z',
      updatedAt: '2020-07-17T21:20:29.667Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 39,
      name: 'Provider orientation learning message',
      message:
        'Our engaging content is backed by over 30 years of scientific research to recommend strategies that work best for medical weight loss.',
      handler: 'orientation.provider.learning',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.362Z',
      updatedAt: '2020-07-17T21:21:23.825Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 38,
      name: 'Provider orientation appointments message',
      message:
        'View your day or the week ahead. Schedule virtual appointments and group visits with patients. Add other organizational providers to appointments for patient consults.',
      handler: 'orientation.provider.appointments',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.360Z',
      updatedAt: '2020-07-17T21:23:25.219Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 42,
      name: 'Recommendation page banner',
      message:
        'You can find customized care recommendations and medical decision support tools here. Our scientifically-based approach individualizes recommendations for your patient based on their demographics, medical and weight history.',
      handler: 'recommendation.page.banner',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:59.288Z',
      updatedAt: '2020-08-26T20:10:49.668Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 40,
      name: 'Goals page banner',
      message:
        'This is where you can monitor your patient’s Active Goals and Wellness Vision. Active Goals will be marked as complete or incomplete to help you understand where your patient has had success or challenges. You can collaborate with your patient to select or create new goals.',
      handler: 'goals.page.banner',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:59.255Z',
      updatedAt: '2020-06-18T09:14:59.255Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 44,
      name: 'White Screen message',
      message: "We're sorry, but we can't find what you're looking for.",
      handler: 'whiteScreen.page.message',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-07-13T16:25:39.526Z',
      updatedAt: '2020-07-13T16:25:39.526Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 43,
      name: 'White Screen header',
      message: "Oops, that didn't work",
      handler: 'whiteScreen.pages.header',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-07-13T16:25:39.525Z',
      updatedAt: '2020-07-13T16:25:39.525Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 45,
      name: 'Maximum providers selected',
      message: 'You have reached the maximum number for selected providers.',
      handler: 'maximum.providers.selected',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-07-13T16:28:04.479Z',
      updatedAt: '2020-07-13T16:28:04.479Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 46,
      name: 'Appointment Deactivated Participants',
      message:
        'Sorry, but the patient/provider in this appointment has been deactivated.\n        Please cancel the appointment or change the participants.',
      handler: 'appointments.deactivated.participants',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-07-13T16:30:11.490Z',
      updatedAt: '2020-07-13T16:30:11.490Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 34,
      name: 'Provider orientation welcome message',
      message:
        'Thank you for choosing Evolve as your partner in delivering weight management care. We will support your patients while providing you with scientifically-based support as you make decisions for their care. We have over 30 years of successful experience with medical weight loss interventions. ',
      handler: 'orientation.provider.welcome',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:58.344Z',
      updatedAt: '2020-07-17T21:19:36.081Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 47,
      name: 'Delete Schedule Setting',
      message: 'Are you sure you want to delete this entry? This action cannot be undone and your entry will be permanently erased.',
      handler: 'delete.schedule.settings',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-07-27T13:57:04.694Z',
      updatedAt: '2020-07-27T13:57:04.694Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 48,
      name: 'Use Regular Hours',
      message: 'Are you sure you want to use regular hours? This action cannot be undone and your prior settings will be erased.',
      handler: 'use.regular.hours',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-07-27T13:57:04.701Z',
      updatedAt: '2020-07-27T13:57:04.701Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 41,
      name: 'Summary page banner',
      message:
        'This page is where you will track your patient’s weight graph, review their medications, write progress notes, and communicate with your patient.',
      handler: 'summary.page.banner',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-06-18T09:14:59.286Z',
      updatedAt: '2020-08-26T20:12:17.728Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 49,
      name: 'Global Banner',
      message:
        '<p>The Evolve platform will be performing maintenance on the evenings of September 21 and 22 starting at 11 PM ET and will last about 2 hours.  If you use Evolve during this time, you could experience delays and performance issues. </p>\n        <p><strong>We apologize for any inconvenience.</strong></p>',
      handler: 'global.banner',
      messageType: 'info',
      hidden: true,
      createdAt: '2020-09-17T00:49:09.436Z',
      updatedAt: '2020-11-19T23:48:18.091Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 54,
      name: 'View as Patient Banner',
      message:
        "You are currently viewing what the patient see.\n         Any changes made by the patient at this moment may not be fully reflected.\n          If you need to adjust the patient's settings, please return to the patient list.",
      handler: 'viewing.as.patient.banner',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-12-15T14:12:48.821Z',
      updatedAt: '2020-12-15T14:12:48.821Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 55,
      name: 'password locked message',
      message:
        "You've reached the maximum number of login attempts and your account has been locked. Please reset your password using the Forgot Your Password link below.",
      handler: 'password.locked.message',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-12-22T14:03:32.966Z',
      updatedAt: '2020-12-22T14:03:32.966Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 56,
      name: 'expired token message',
      message:
        "<div>\n        <p>You have clicked an expired link. Please email us at <a href='mailto:support@evolveme.com'> support@evolveme.com </a>for an updated link.</p>\n        </div>",
      handler: 'expired.token.message',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-12-22T14:03:32.974Z',
      updatedAt: '2020-12-22T14:03:32.974Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 57,
      name: 'invalid token message',
      message:
        "<div>\n        <p>Link is invalid. Please email us at <a href='mailto:support@evolveme.com'> support@evolveme.com </a>for an updated link.</p>\n        </div>",
      handler: 'invalid.token.message',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-12-22T14:03:33.767Z',
      updatedAt: '2020-12-22T14:03:33.767Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 50,
      name: 'migrated patient dashboard banner',
      message:
        'Congratulations! You’ve been migrated to Evolve, our new health and weight management platform with added features and a slick new design. We hope you enjoy your journey!',
      handler: 'migrated.patient.dashboard.banner',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-09-24T05:15:50.549Z',
      updatedAt: '2020-09-24T05:15:50.549Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 52,
      name: 'Programs: Inherited courses',
      message: 'The courses inherited from the parent program will be included in the current program\n        unless excluded explicitly',
      handler: 'programs.inherited',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-11-03T10:24:20.510Z',
      updatedAt: '2020-11-03T10:24:20.510Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 51,
      name: 'Programs: Parent only courses',
      message: 'These courses exist in the parent program only. Make sure to copy them to the organizational site',
      handler: 'programs.parentOnly',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-11-03T10:24:20.510Z',
      updatedAt: '2020-11-03T10:24:20.510Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 53,
      name: 'Programs: Child only courses',
      message: 'Include the organizational courses into the program.',
      handler: 'programs.childOnly',
      messageType: 'info',
      hidden: false,
      createdAt: '2020-11-03T10:24:20.522Z',
      updatedAt: '2020-11-03T10:24:20.522Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 59,
      name: 'incorrect format token message',
      message:
        "<div>\n        <p>Link is not in the correct format. Please email us at <a href='mailto:support@evolveme.com'> support@evolveme.com </a>for an updated link.</p>\n        </div>",
      handler: 'incorrect.format.token.message',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-12-22T14:03:33.767Z',
      updatedAt: '2020-12-22T14:03:33.767Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 60,
      name: 'Food logging: blank message',
      message: 'You do not yet have any foods logged for',
      handler: 'logging.food.blank',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-01-11T12:15:08.801Z',
      updatedAt: '2021-01-11T12:15:08.801Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 58,
      name: 'user notfound',
      message:
        "<div>\n        <p>User not found. Please email us at <a href='mailto:support@evolveme.com'> support@evolveme.com </a>for an updated link.</p>\n        </div>",
      handler: 'user.not.found',
      messageType: 'error',
      hidden: false,
      createdAt: '2020-12-22T14:03:33.767Z',
      updatedAt: '2021-02-15T13:49:30.728Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 63,
      name: 'sideBarTitle',
      message: 'Intellihealth Evolve',
      handler: 'sideBarContent.title',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-02-17T15:23:09.235Z',
      updatedAt: '2021-02-17T17:58:32.901Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 62,
      name: 'sideBarContent',
      message:
        '<p>The future of weight management is here!</p> <p>Intellihealth Evolve is an online platform that connects patients to comprehensive medical weight loss treatment and supports their providers each step of the way.</p> <p>Backed by over 30 years of clinical data, Evolve is based on three pillars: medical guidance, education and behavioral change.</p> <p>The program is designed to meet patients wherever they are on their weight loss journey with realistic goals and improved habits that lead to lasting results.</p>',
      handler: 'sideBarContent.description',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-02-17T15:23:09.232Z',
      updatedAt: '2021-02-17T18:02:34.086Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 64,
      name: 'secure account message title',
      message: 'Secure your account',
      handler: 'secure.account.message.title',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-03T11:58:59.969Z',
      updatedAt: '2021-03-03T11:58:59.969Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 66,
      name: '2FA: Authentication enabled',
      message:
        'Enabling two-factor authentication will mean that all org admins and providers\n         will be prompted to set up 2FA upon their next login.',
      handler: '2fa.enable.confirm',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-18T18:33:16.226Z',
      updatedAt: '2021-03-18T18:33:16.226Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 67,
      name: '2FA: Google authentication',
      message:
        'By selecting Google Authenticator, you may use the app to verify\n         your account everytime you login or when your session has timed-out.',
      handler: '2fa.google',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-18T18:33:16.230Z',
      updatedAt: '2021-03-18T18:33:16.230Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 68,
      name: '2FA: Email authentication',
      message:
        'By selecting email, we will send a 6-digit code to your\n         email which will be used everytime you login or when your session has timed-out.',
      handler: '2fa.email',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-18T18:33:16.246Z',
      updatedAt: '2021-03-18T18:33:16.246Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 69,
      name: '2FA: Authentication description for organization',
      message: 'When this is enabled, Org Admins and providers are required to use Two-Factor Authentication',
      handler: '2fa.organization.description',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-18T18:33:16.250Z',
      updatedAt: '2021-03-18T18:33:16.250Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 70,
      name: '2FA: Authentication configuration description',
      message:
        'If you configure now, you will be logged out of Evolve and instructed how to use two-factor authentication.\n         If you decide to configure later, you will be instructed the next time you sign in.',
      handler: '2fa.configure.description',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-18T18:33:16.248Z',
      updatedAt: '2021-03-18T18:33:16.248Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 74,
      name: 'googleFitConnectedMessage',
      message: 'Google Fit account successfully connected.',
      handler: 'googleFit.connected.message',
      messageType: 'success',
      hidden: false,
      createdAt: '2021-04-26T15:41:55.833Z',
      updatedAt: '2021-04-26T16:34:24.451Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 72,
      name: 'GoogleFitPopupTitle',
      message: 'New Google Fit integration!',
      handler: 'googleFit.updatedModal.title',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-04-26T15:41:55.183Z',
      updatedAt: '2021-04-26T21:33:02.250Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 71,
      name: 'GoogleFitPopupContent',
      message: 'Did you know you can now connect a digital scale to Evolve by linking it with a Google Fit account? Click Connect to get started.',
      handler: 'googleFit.updatedModal.content',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-04-26T15:41:55.183Z',
      updatedAt: '2021-04-26T21:33:53.278Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 75,
      name: 'Google Fit unique email error',
      message: 'This google account is already connected to another Evolve account.',
      handler: 'googleFit.unique.email',
      messageType: 'error',
      hidden: false,
      createdAt: '2021-05-05T11:56:51.126Z',
      updatedAt: '2021-05-05T11:56:51.126Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 65,
      name: 'secure account message',
      message: 'We need a little more information to keep your account secure. Please take a moment to update your address and phone number.',
      handler: 'secure.account.message',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-03-03T11:58:59.968Z',
      updatedAt: '2021-05-18T17:43:47.500Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 76,
      name: 'SmsConfigsTitle',
      message: 'Set Up SMS Notifications',
      handler: 'updateSmsConfigs.updatedModal.title',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-05-20T16:36:27.834Z',
      updatedAt: '2021-05-20T16:36:27.834Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 77,
      name: 'SmsConfigsContent',
      message: 'Did you know you can now get Evolve notifications via text message?',
      handler: 'updateSmsConfigs.updatedModal.content',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-05-20T16:36:27.837Z',
      updatedAt: '2021-05-20T16:36:27.837Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 78,
      name: 'verifyExplanation',
      message:
        "Questionnaire data can be updated by selecting Retake below. Or if you'd like to verify the information is still accurate, select Verify.",
      handler: 'assessment.verifyExplanation',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-06-18T20:50:28.154Z',
      updatedAt: '2021-06-22T19:33:21.052Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 79,
      name: 'confirmVerify',
      message: 'Verify Assessment Answers.\nThis confirms the answers are still accurate and updates the completion date.',
      handler: 'assessment.confirmVerify',
      messageType: 'info',
      hidden: false,
      createdAt: '2021-06-18T20:50:28.159Z',
      updatedAt: '2021-06-22T19:39:10.317Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 80,
      name: 'RPM Logs Blank',
      message:
        'Consider adding patients to Remote Monitoring to help with Billable Events.  Use Patient Settings to add a patient and after consent, Evolve will track device readings for patients who meet the thresholds for specific Remote Monitoring codes.',
      handler: 'rpm.logs.blank',
      messageType: 'info',
      hidden: false,
      createdAt: '2019-12-20T15:01:30.327Z',
      updatedAt: '2019-12-20T15:01:30.327Z',
      createdBy: null,
      updatedBy: null,
    },
  ],
};
